
import {Component, Prop, Vue} from "vue-property-decorator";
import {GecmisSohbeti} from "@/plugins/raporAiGecmisDeposu";
import {ProgramPaths} from "@/enum/ProgramPaths";

/**
 * DEV-3011 — sohbet geçmişi çekmecesi (geçici çözüm).
 * Yalnız görüntüler ve olay yayar; saklama işi raporAiGecmisDeposu'nda. Vue 3 tasarım
 * turunda bu bileşen değişse de sözleşme (value / sec / sil / temizle) korunur.
 */
@Component({})
export default class RaporAiGecmis extends Vue {
  @Prop({default: false}) value!: boolean;
  @Prop({default: () => []}) sohbetler!: Array<GecmisSohbeti>;
  @Prop({default: 20}) sohbetSiniri!: number;
  @Prop({default: 30}) gunSiniri!: number;

  /** Vuetify, 'app' çubukların yüksekliğini burada tutar; yoksa varsayılan yükseklik. */
  get ustBosluk(): number {
    const uygulama: any = (this.$vuetify as any).application;
    return (uygulama && uygulama.top) ? uygulama.top : 48;
  }

  raporaGit(sohbet: GecmisSohbeti) {
    const yol = ProgramPaths.ofispro + "/rapor/" + sohbet.kayitliRaporId;
    if (this.$route.path !== yol) this.$router.push(yol);
    this.$emit("input", false);
  }

  mesajSayisi(sohbet: GecmisSohbeti): number {
    return (sohbet.mesajlar || []).filter(m => m.rol === "kullanici").length;
  }

  zamanEtiketi(zaman: number): string {
    const fark = Date.now() - zaman;
    const dakika = Math.floor(fark / 60000);
    if (dakika < 1) return "az önce";
    if (dakika < 60) return dakika + " dk önce";
    const saat = Math.floor(dakika / 60);
    if (saat < 24) return saat + " saat önce";
    const gun = Math.floor(saat / 24);
    if (gun < 7) return gun + " gün önce";
    return new Date(zaman).toLocaleDateString("tr-TR");
  }
}
